module.exports = __webpack_public_path__ + "static/img/pe.51c093f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pe.png
// module id = EjhR
// module chunks = 1